<template>
    <div class="highlightCircle" :style="{background:currentIndex==6?`conic-gradient( #feae00 0% 100%)`:`conic-gradient( #feae00 0% ${persent}%, #ccc ${persent}% 100% )`}">
        <div class="innerCircle">
            <span class="currentItem">{{currentIndex}}</span>
            <span class="totaleItem">/6</span>
        </div>
    </div>
    
</template>

<script>
export default {
    props:['currentIndex'],
    data(){
      return{
        persent:14.28
      }
    },
    mounted: function() {
      let per = Math.ceil(this.currentIndex/7*100)
      this.persent =  per>100?100:per
    }
}
</script>

<style lang="scss">
.highlightCircle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: conic-gradient(
    #feae00 0% 14.28%,  /* 高亮20%的部分 */
    #ccc 14.28% 100%  /* 剩余的80% */
  );
  position: relative;
  .innerCircle{
    position: absolute;
    left: 6px;
    right: 6px;
    top: 6px;
    bottom: 6px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .currentItem{
        color: #000;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
    .totaleItem{
        color: var(---3, #999);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
  }
}

@media screen and (max-width:767px) { 
  .highlightCircle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  // background: conic-gradient(
  //   gold 0% 20%,  /* 高亮20%的部分 */
  //   #ccc 20% 100%  /* 剩余的80% */
  // );
  position: relative;
  .innerCircle{
    position: absolute;
    left: 1vw;
    right: 1vw;
    top: 1vw;
    bottom: 1vw;
    background: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .currentItem{
        color: #000;
        text-align: center;
        font-size: 3.6vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
    .totaleItem{
        color: var(---3, #999);
        font-size: 3vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
  }
}
}

@media screen  and (min-width: 767px) and (max-width: 1200px){
  .highlightCircle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  // background: conic-gradient(
  //   gold 0% 20%,  /* 高亮20%的部分 */
  //   #ccc 20% 100%  /* 剩余的80% */
  // );
  position: relative;
  .innerCircle{
    position: absolute;
    left: 0.6vw;
    right: 0.6vw;
    top: 0.6vw;
    bottom: 0.6vw;
    background: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .currentItem{
        color: #000;
        text-align: center;
        font-size: 2vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
    .totaleItem{
        color: var(---3, #999);
        font-size: 1.4vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
  }
}
}
</style>